var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{ref:"thumbnailContainer",staticClass:"thumbnail-container"},[(_vm.livePreviewUrl)?_c('iframe',{ref:"iframe",staticClass:"iframe",staticStyle:{"height":"80vh","width":"100%"},attrs:{"src":_vm.livePreviewUrl,"frameborder":"0"}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }